import React from 'react';
import { useParams } from 'react-router-dom';
import { toOrganizationKey, toWorkspaceKey } from '../utils/apiUtils';

export const useWorkspaceKey = () => {
    const { workspaceId } = useParams();
    return Boolean(workspaceId) ? toWorkspaceKey(workspaceId) : null;
};
